import { defineComponent as s, createElementBlock as t, createCommentVNode as i, openBlock as r, createElementVNode as m, toDisplayString as l } from "vue";
const p = ["alt", "src"], c = {
  key: 1,
  class: "header-name"
}, y = /* @__PURE__ */ s({
  __name: "HeaderItemMeta",
  props: {
    logo: {},
    projectName: {},
    primaryVersionUid: {}
  },
  emits: ["navigate"],
  setup(d, { emit: a }) {
    const n = a;
    return (e, o) => e.logo ? (r(), t("button", {
      key: 0,
      class: "header-item-logo",
      type: "button",
      onClick: o[0] || (o[0] = (g) => n("navigate", e.primaryVersionUid, "version"))
    }, [
      m("img", {
        alt: e.projectName,
        class: "header-item-logo-image",
        src: e.logo
      }, null, 8, p)
    ])) : e.projectName ? (r(), t("span", c, l(e.projectName), 1)) : i("", !0);
  }
});
export {
  y as default
};
